export default {
  visit: {
    status: {
      10: {
        title: 'ожидает',
        color: 'success'
      },
      20: {
        title: 'в работе',
        color: 'danger'
      },
      30: {
        title: 'рекомендации даны',
        color: 'warning'
      },
      40: {
        title: '-',
        color: 'info'
      },
    },
    title: {
      0: "Выберите доступный визит",
      1: "Заполненые анкеты",
      2: "Данные приборов",
      3: "Заполение рекомендаций",
      4: "Индекс здоровья"
    }
  },
  questionnaire: {
    rowType: {
      radio: 20,
      select: 40,
      number: 60,
      tag: 80,
    }
  },
  session: {
    title: {
      "session.create": "Новый визит",
      "session.card": "",
      "session.questionnaire": "Анкета клиента",
      "session.documents": "Документы",
      "session.device": "Данные приборов",
      "session.close": "Заключение"
    }
  }
}
